export enum RealtimeRoom {
  Notifications = "notifications",
  ChatRoom = "chatroom",
}
